import { Routes } from '@angular/router';
import { Workflow } from './_components/workflow/workflow';
import { routingConstants } from './_constants/routing-constants.const';
import { MsalGuard } from '@azure/msal-angular';
import { Login } from './_components/login/login';
import { AnonymousGuard } from './_guards/anonymous.guard';
import { AccessGuard, ManagerGuard } from './_guards/access.guard';
import { NoAccess } from './_components/no-access/no-access';
import { UserManagement } from './_components/user-management/user-management';

export const routes: Routes = [
  { path: routingConstants.login, component: Login, canActivate: [AnonymousGuard] },
  { path: routingConstants.noAccess, component: NoAccess, canActivate: [MsalGuard] },
  { path: routingConstants.manager, component: UserManagement, canActivate: [MsalGuard, AccessGuard, ManagerGuard] },
  { path: routingConstants.transcriber, component: Workflow, canActivate: [MsalGuard, AccessGuard] },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
